import { useMemo } from "react";
import { Provider } from "react-redux";

import Opportunities from "../components/Opportunities";

export default () => {
  const store = useMemo(() => ReactOnRails.getStore("layoutStore"), []);

  return (
    <Provider store={store}>
      <Opportunities />
    </Provider>
  );
};
